import React from 'react';
// import LazyLoad from 'react-lazyload';
import makeStyles from '@material-ui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    cursor: 'pointer',
    flexBasis: 'calc((100vw - 10px) / 2)',
    marginBottom: 10,
    background: '#FFFFFF',
    flexDirection: 'column'
  },
  cover: {
    height: '114px',
    '& img': {
      display: 'block',
      maxWidth: '100%',
      height: '100%',
      margin: '0 auto',
      objectFit: 'cover',
    }
  },
  seal: {
    width: '100%',
    height: 114
  },
  bottom: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingLeft: 13,
    alignItems: 'flex-start',
    height: theme.spacing(8),
    '& span:first-child': {
      color: '#3B454F',
      fontSize: 15,
      lineHeight: '23px',
      fontFamily: 'SourceHanSansCN-Regular'
    },
    '& span:last-child': {
      color: '#43C494',
      fontSize: 13,
      fontWeight: 400,
      lineHeight: '20px'
    }
  }
}));

function Item({ isAndroid, t, cover, id, lowestPrice, name, unit, onClick, version = 0 }) {
  const styles = useStyles();
  return (
    <div
      data-path={`/good/detail?commodityId=${id}&t=${t}&isAndroid=${isAndroid}&version=${version}`}
      onClick={onClick}
      onTouchEnd={onClick}
      className={styles.root}
    >
      {/* <LazyLoad>
      </LazyLoad> */}
      <div className={styles.cover}>
        <img src={cover} />
      </div>
      {/*<img className={styles.seal} src={cover} />*/}
      <div className={styles.bottom}>
        <span>{name}</span>
        <span>{lowestPrice}知米币起</span>
      </div>
    </div>
  );
}

export default Item;
